import {Counter} from './types';

export class FakeCounter implements Counter {
    name: string;

    private warnShown = false;

    constructor(name: string) {
        this.name = name;
    }

    hit() {
        this.warnOnce();
    }

    params() {
        this.warnOnce();
    }

    userParams() {
        this.warnOnce();
    }

    reachGoal() {
        this.warnOnce();
    }

    reachGoals() {
        this.warnOnce();
    }

    private warnOnce() {
        if (!this.warnShown) {
            console.warn(`Counter "${this.name}" not found`);
            this.warnShown = true;
        }
    }
}
